<template>
  <div class="qa">
    <div class="qa__title">
      <span class="qa__title">{{ title ? title + ' ' : '' }}Quick Add</span>
    </div>
    <div class="qa__body">
      <div
        id="nav-urls"
        class="tab-pane fade"
        role="tabpanel"
        aria-labelledby="nav-urls-tab"
      >
        <br>
        <form>
          <div class="form-group">
            <div>
              <div class="ctrl ctrl__left">
                <div style="display: inline" />
              </div>
              <div class="ctrl ctrl__right">
                <div style="display: inline">
                  <label class="qa__limit-text">
                    Limit {{ recordLimit }}
                  </label>
                </div>
              </div>
              <br>
              <div id="quick_add_url_table" />
              <button
                type="button"
                class="qa__button qa__button_add_row"
                @click="addRow"
              >
                <base-material-design-icon
                  icon="plus"
                  class="qa__icon"
                />
                <span>Add Row</span>
              </button>
            </div>
            <div class="qa__error_message">
              <span
                v-show="invalidText"
                class="invalid-count"
              >
                {{ invalidText }}
              </span>
            </div>
            <div class="qa__controls">
              <button
                type="button"
                class="qa__button qa__button_clear_table"
                @click="clearTable"
              >
                <base-material-design-icon
                  icon="restore"
                  class="qa__icon"
                />
                <span>Reset Data</span>
              </button>
              <button
                v-show="!readClipboardRestricted"
                style=""
                type="button"
                class="qa__button qa__button_import_clipboard"
                @click="importClipboard"
              >
                <base-material-design-icon
                  icon="paste"
                  class="qa__icon"
                />
                <span>Import from Clipboard</span>
              </button>
              <label class="qa__button qa__button_file_upload">
                <input
                  ref="fileUploadUrls"
                  type="file"
                  accept=".csv, .tsv"
                  @change="handleFileChange($event)"
                >
                <base-material-design-icon
                  icon="upload"
                  class="qa__icon"
                />
                <span>Upload File</span>
              </label>
              <button
                type="button"
                class="qa__button qa__button_download_template"
                @click="downloadTemplate()"
              >
                <base-material-design-icon
                  icon="fileDocument"
                  class="qa__icon"
                />
                <span>download template</span>
              </button>
              <button
                type="button"
                class="qa__button qa__button_cancel"
                @click="close()"
              >
                Cancel
              </button>
              <input
                type="hidden"
                name="action"
                value="Add Links"
              >
              <input
                id="new_keywords_modal_button_add_urls"
                type="button"
                name="action"
                value="Add Links"
                class="btn btn-primary submit-button qa__button qa__button_submit"
                :class="{ 'submit-disabled': !submitAllowed }"
                :disabled="!submitAllowed"
                @click.prevent="apply()"
              >
            </div>
          </div>
        </form>
      </div>
    </div>
    <base-material-design-icon
      ref="icon"
      style="font-size:14px;"
      icon="closeCircle"
    />
  </div>
</template>

<script>
import papaparse from 'papaparse'
import BaseModalMixins from '@/common/BaseModalMixins'
import Tabulator from 'tabulator-tables'
import ToasterService from '@/services/toasterService'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'BaseQuickAdd',
  mixins: [BaseModalMixins],
  props: {
    title: {
        type: String,
        required: false,
        default: null
    },
    columns: {
        type: Array,
        required: true,
        validator (value) { 
            // Expects an Array of Objects - see features/links/Links.vue for original example
            // Should accept any Tabulator Column Component property
            // {
            //   title: String (required),
            //   required: Boolean,
            //   options: Array,
            //   editor: String,
            //   formatter: String,
            //   validateUrl: Boolean,
            //   validateWebProp: Boolean,
            //   ...   
            // }
            return value.every(obj => obj.title)
        }
    }
    // webPropertyPatterns: [],
    // mappedUrls: []
  },
  data () {
    return {
      recordLimit: 250,
      formData: '',
      rawIconHtmlString: '',
      urlValidationRegex: /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i,
      readClipboardRestricted:
        navigator.userAgent.indexOf('Firefox') > -1 ||
        navigator.userAgent.indexOf('Trident') > -1 ||
        navigator.userAgent.indexOf('MSIE') > -1,
      placeholderSecondLine: `(${
        navigator.platform.indexOf('Mac') > -1 ? 'Cmd' : 'Ctrl'
      } + v)`,
      submitAllowed: false,
      invalidText: null,
      mounted: false,
      urlFields: [],
      webPropFields: []
    }
  },
  computed: {
    ...mapState('webProperty', ['webProperties']),
    urlValidationFields () {
      return this.columns.filter(column => column.validateUrl).map(column => this.getFieldNameFromTitle(column.title))
    },
    webPropValidationFields () {
      return this.columns.filter(column => column.validateWebProp).map(column => this.getFieldNameFromTitle(column.title))
    },
    webPropertyPatterns () {
      return this.webProperties.map(prop => {
        return prop.pattern.map(pattern => {
          return pattern.value
        })
      }).flat()
    },
    computedFields () {
      return this.computedColumns.map(column => column.field)
    },
    computedColumns () {
      return this.columns.map(column => {
        const field = this.getFieldNameFromTitle(column.title)
        const validator = [ ...column.validator || [] ]
        let editor = column.editor ?? 'input'
        const editorParams = {
          showListOnEmpty: true,
          freetext: true,
          values: column.options ?? [],
          ...column.editorParams
        }
        if (column.required) {
          validator.push('required')
        }
        if (column.validateUrl) {
          validator.push({ type: this.isUrlValid })
        }
        if (column.validateWebProp) {
          validator.push({ type: this.isWebPropValid })
        }
        if (column.editor === 'date') {
          column.cellEdited = (cell) => {
            cell.setValue = ''
          }
          editor = this.dateEditor
        }
        return {
          ...column,
          field: field,
          validator: validator,
          editor: editor,
          editorParams: editorParams,
        }
      })
    },
    tableConfig () {
      return {
        maxHeight: 400,
        data: [],
        columns: [
          {
            formatter: () => {
              return this.rawIconHtmlString // this provides material-design-icon as raw html
            },
            field: 'delete',
            headerSort: false,
            width: 40,
            hozAlign: 'center',
            cellClick: this.deleteRow,
            download: false
          },
          ...this.computedColumns
        ],
        layout: 'fitDataStretch',
        tooltipsHeader: true,
        tooltips: (cell) => {
          let tooltipText = ''
          const cellValue = cell.getValue() || ''
          if (cell.validate()) {
            tooltipText = cellValue
          } else {
            const errors = []
            if (this.urlValidationFields.includes(cell.getColumn().getField())) {
              if (!this.isUrlValid(cell, cell.getValue())) {
                errors.push('Invalid URL format!')
              }
            }
            if (this.webPropValidationFields.includes(cell.getColumn().getField())) {
              if (!this.isWebPropValid(cell, cell.getValue())) {
                errors.push('Invalid Web Property!')
              }
            }
            if (!errors.length) {
              tooltipText = `Invalid ${cell.getColumn().getDefinition().title}!`
            } else {
              tooltipText = errors.join('\n')
            }

          } 
          return tooltipText
        },
        tableBuilt: this.handleTableBuilt,
        clipboard: true,
        clipboardPasteAction: 'replace',
        clipboardPasteParser: this.parsePaste,
        clipboardPasteError: this.handlePasteError,
        clipboardPasted: this.handlePasted,
        dataEdited: this.updateForm,
        validationMode: 'highlight',
        placeholder: `<div><span style="display:block;">Click here to import from clipboard</span><span style="display:block;text-align:center;">${this.placeholderSecondLine}</span></div>`
      }
    }
  },
  watch: {
    mappedUrls: {
      handler () {
        this.table.getColumn('url').getDefinition().editorParams.values = this.mappedUrls.map(url => url.label)
        this.table.redraw()
      },
      deep: true
    }
  },
  mounted () {
    this.rawIconHtmlString = this.$refs.icon.$el.outerHTML.toString()
    this.$refs.icon.$el.parentNode.removeChild(this.$refs.icon.$el)

    this.table = new Tabulator('#quick_add_url_table', this.tableConfig)

    this.mounted = true
  },
  methods: {
    dateEditor (cell, onRendered, success, cancel) {
        //create and style input
        var cellValue = moment(cell.getValue(), "MM/DD/YYYY").format("YYYY-MM-DD"),
        input = document.createElement("input");

        input.setAttribute("type", "date");

        input.style.padding = "4px";
        input.style.width = "100%";
        input.style.boxSizing = "border-box";

        input.value = cellValue;

        onRendered(function(){
            input.focus();
            input.style.height = "100%";
        });

        function onChange(){
            if (!input.value) {
              success('')
            }
            if(input.value != cellValue){
                success(moment(input.value, "YYYY-MM-DD").format("MM/DD/YYYY"));
            }else{
                cancel();
            }
        }

        //submit new value on blur or change
        input.addEventListener("blur", onChange);

        //submit new value on enter
        input.addEventListener("keydown", function(e){
            if(e.keyCode == 13){
                onChange();
            }

            if(e.keyCode == 27){
                cancel();
            }
        });

        return input;
    },
    getFieldNameFromTitle (title) {
      return title.toLowerCase().split(' ').join('_')
    },
    handleFileChange (e) {
      const file = e.target.files[0]
      let reader = new FileReader()
      reader.readAsText(file)
      reader.onload = () => {
        this.handleDataToTable(reader.result)
        this.$refs.fileUploadUrls.value = null
      }
      reader.onerror = function () {
        console.log(reader.error)
      }
    },
    downloadTemplate () {
      this.table.download('csv', 'quick-add-template.csv')
    },
    isTableValid (table) {
      const validated = table.validate()
      return validated && !validated.length
    },
    toggleSubmitAllowed (table) {
      const rowCount = table.getDataCount()
      const overRowLimit = rowCount > this.recordLimit
      if (this.isTableValid(table) && rowCount && !overRowLimit) {
        this.invalidText = null
        this.submitAllowed = true
      } else if (overRowLimit) {
        this.invalidText = `Too many records! (${rowCount} / ${this.recordLimit})`
        this.submitAllowed = false
      } else {
        const invalidCount = table.getInvalidCells().length
        if (invalidCount) {
          this.invalidText =
            invalidCount > 1
              ? `There are ${invalidCount} invalid cells!`
              : `There is 1 invalid cell!`
        } else {
          this.invalidText = null
        }
        this.submitAllowed = false
      }
    },
    addRow () {
      const row = this.tableConfig.columns.reduce((previous, current) => {
        previous[current.field] = ''
        return previous
      }, {})
      this.table.addRow(row)
      this.toggleSubmitAllowed(this.table)
    },
    clearTable () {
      this.table.clearData()
      this.toggleSubmitAllowed(this.table)
    },
    importClipboardFromPlaceholder (event) {
      const isPlaceholder = Array.from(event.currentTarget.children).filter(
        (el) => {
          return el.classList.contains('tabulator-placeholder')
        }
      ).length
      const isDeleteBtn = event.target.matches('path, svg, .tabulator-cell')
      if (isPlaceholder && !isDeleteBtn) {
        this.table.clearData()
        this.importClipboard()
      }
    },
    handleDataToTable (data) {
      const parsedData = this.parsePaste(data)
      if (!parsedData) {
        this.handlePasteError(data)
      } else {
        this.table.clearData()
        parsedData.forEach((row) => this.table.addRow(row))
        this.handlePasted()
      }
    },
    importClipboard () {
      try {
        navigator.clipboard
          .readText()
          .then((clipboard) => {
            this.handleDataToTable(clipboard)
          })
          .catch((err) => {
            console.error('Failed to read clipboard contents: ', err)
          })
      } catch (e) {
        console.error(e)
      }
    },
    deleteRow (e, cell) {
      if (this.table.getDataCount() < 2) {
        this.table.clearData()
      } else {
        cell.getRow().delete()
      }
      this.toggleSubmitAllowed(this.table)
    },
    mapLineToRowObject (row, columnIndices) {
      if (!columnIndices) {
        columnIndices = this.computedFields.reduce((previous, current, index) => {
          previous[current] = index
          return previous
        }, {})
      }
      const result = {}
      for (const k in columnIndices) {
        result[k] = row[columnIndices[k]] || ''
      }
      this.parseRowValues(result)
      return result
    },
    parseRowValues (row) {
      for (const k in row) {
        let setEmpty = false
        let mappedValue = null
        const columnDefinition = this.table.getColumn(k).getDefinition()
        // Check if this is a DATE column - simple string match
        if (columnDefinition.field.includes('date')) {
          let parsedDate = moment(row[k])
          if (parsedDate.isValid()) {
            mappedValue = parsedDate.format('MM/DD/YYYY')
          } else {
            setEmpty = true
          }
        } else {
          // Check if this is a SELECT column
          mappedValue = columnDefinition.editorParams.values.find(option => {
            return option.label.toLowerCase() === row[k].toLowerCase()
          })?.value
          if (!mappedValue && !columnDefinition.editorParams.freetext) {
            setEmpty = true
          } 
        }
        row[k] = setEmpty ? '' : mappedValue ?? row[k]
      }
    },
    validateHeader (row) {
      return this.computedFields.some(field => row.includes(field))
    },
    parsePaste (clipboard) {
      let clipboardArray = []
      try {
        clipboard = papaparse.parse(clipboard).data
        let columnIndices = null
        let firstRow = clipboard[0].map((col) => this.getFieldNameFromTitle(col))
        if (this.validateHeader(firstRow)) {
          columnIndices = firstRow.reduce((acc, cur, idx) => {
            if (this.computedFields.includes(cur)) {
              acc[cur] = idx
            }
            return acc
          }, {})
          clipboard = clipboard.slice(1)
        }
        clipboardArray = clipboard.map((row) =>
          this.mapLineToRowObject(row, columnIndices)
        )
        // clipboardArray = clipboardArray.filter(row => row.url)

        // handles dataChanged if Ctrl+v paste
        this.updateForm(clipboardArray)
      } catch {
        return false
      }
      return clipboardArray
    },
    handlePasted () {
      this.toggleSubmitAllowed(this.table)
    },
    handlePasteError () {
      let errorText =
        'There was an issue pasting your selection...\n\nDid you select the appropriate columns?'
      ToasterService.showToast(ToasterService.INFO_TYPE, errorText)
    },
    isValidWebProp (url) {
      return this.webPropertyPatterns.some((pattern) =>
        url.toLowerCase().startsWith(pattern.slice(0, -1).toLowerCase())
      )
    },
    isUrlValid (cell, value) {
      return !value || value.trim().match(this.urlValidationRegex)
      // return true
    },
    isWebPropValid (cell, value) {
      return !value || this.isValidWebProp(value.trim())
      // return true
    },
    formatRowData (rowData) {
      return this.computedFields.reduce((previous, current) => {
        previous += `${rowData[current]}\t`
        return previous
      }, '') + '\n'
    },
    updateForm (data) {
      // const tsvData = data.reduce((acc, cur) => {
      //   return acc + this.formatRowData(cur)
      // }, '')
      this.formData = data
      this.toggleSubmitAllowed(this.table)
    },
    handleTableBuilt () {
      const tableHolder = document.getElementsByClassName(
        'tabulator-tableHolder'
      )
      Array.from(tableHolder).forEach((element) => {
        element.addEventListener('click', this.importClipboardFromPlaceholder)
      })
    },
    close () {
      this.$emit('close')
    },
    apply () {
      const data = this.formData.map(row => {
          const newRow = { ...row }
          delete newRow['delete']
          return newRow
        })
      this.$emit('apply', data)
    }
  }
}
</script>

<style>
.tabulator-validation-fail {
  background-color: #ffdddd;
  border: none !important;
}

.tabulator-placeholder {
  cursor: pointer;
  height: 100%;
  background-color: #f4f6fb;
}
</style>
<style scoped lang="scss">

input[type="file"] {
  display: none;
}

input[type="checkbox"] {
  cursor: pointer;
}

.submit-disabled {
  cursor: default !important;
  opacity: 0.4;
}

.qa {
  border-radius: 13px;
  &__title {
    display: block;
    text-align: center;
    font-size: 32px;
    font-weight: 500;
  }
}

.ctrl {
  display: inline-flex;
  height: 30px;
  margin-bottom: 5px;

  &__left {
    width: 50%;
    justify-content: flex-start;
  }

  &__right {
    width: 50%;
    justify-content: flex-end;
  }
}

.qa {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding-top: 40px;
  // background-color: $rfx-background-color;

  &__body {
      padding: 0 40px 40px 40px;
  }

  &__icon {
    margin-right: 2px;
    font-size: 15px;
  }

  &__error_message {
    height: 10px;
    > span {
      float: right;
    }
  }


  &__controls {
    display: flex;
    margin-top: 30px;
  }

  &__limit-text {
    font-weight: 600;
  }


  &__button {
    height: 40px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    border: none;
    outline: none;
    cursor: pointer;

    color: $rfx-dark-march;
    background-color: #fff;

    &_submit {
      background-color: $rfx-medium-march;
      color: #fff;
    }

    &_add_row {
      width: 100%;
    }

    &_clear_table {
      margin-right: 10px;
    }

    &_import_clipboard {
      margin-right: 10px;
    }

    &_cancel {
      margin-left: auto;
      margin-right: 10px;
    }

    &_file_upload {
      display: flex;
      margin-right: 10px;
      > span {
        margin: 18px 0;
      }
    }

    &_download_template {
      margin-right: 0 10px;
    }
  }

}
</style>
